var map = {
	"./calculator.svg": 223,
	"./excel.svg": 224,
	"./exception_frame.png": 225,
	"./exception_frame.svg": 226,
	"./no_calculator.svg": 227,
	"./no_disconnect.svg": 228,
	"./no_headphones.svg": 229,
	"./no_instant_messaging.svg": 230,
	"./no_internet_browsing.svg": 231,
	"./no_leaving_camera.svg": 232,
	"./no_local_browsing.svg": 233,
	"./no_materials.svg": 234,
	"./no_pause.svg": 235,
	"./no_people_in_room.svg": 236,
	"./no_phone.svg": 237,
	"./no_tv_radio.svg": 238,
	"./notes.svg": 239,
	"./pdf.svg": 240,
	"./people_with_interaction.svg": 241,
	"./people_without_interaction.svg": 242,
	"./powerpoint.svg": 243,
	"./rule_frame.png": 244,
	"./rule_frame.svg": 245,
	"./specific_websites.svg": 246,
	"./textbooks.svg": 247,
	"./word.svg": 248
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 222;